import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { RegionInfo, XpoLtlAuthenticationService } from '@xpo-ltl/ngx-auth';
import { XpoShellRoute } from '@xpo-ltl/ngx-ltl-core/shell';
import { mergeMap, tap } from 'rxjs/operators';
import { AppConfigsService } from './arsenal-components/services/app-configs.service';
import { XpoLtlLoggedInUserService } from './arsenal-components/services/logged-in-user.service';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { ConfigManagerProperties } from './shared/enums/config-manager-properties.enum';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  title: string;
  build: string;
  routes: XpoShellRoute[] = [];

  apiComponentRoute = `/${AppRoutes.COMPONENTS_PAGE}`;
  aemRoute = `/${AppRoutes.AEM_PAGE}`;
  ensembleConfigRoute = `/${AppRoutes.ENSEMBLE_CONFIG_PAGE}`;
  componentOwnershipRoute = `/${AppRoutes.COMPONENT_OWNERSHIP}`;

  constructor(
    private configManagerService: ConfigManagerService,
    private router: Router,
    private appConfigsService: AppConfigsService,
    private loggedInUserService: XpoLtlLoggedInUserService,
    private xpoLtlAuthService: XpoLtlAuthenticationService,
    private primengConfig: PrimeNGConfig
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    /** Shell setup */
    this.title = 'Arsenal';
    this.build = this.configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion);
  }

  get isUserMaintAdmin$() {
    return this.appConfigsService.isUserMaintAdmin.asObservable();
  }

  get isUserEnsemble$() {
    return this.appConfigsService.isUserEnsemble.asObservable();
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;

    const region = this.configManagerService.getSetting<string>(ConfigManagerProperties.region);
    const prod = this.configManagerService.getSetting<boolean>(ConfigManagerProperties.production);

    this.xpoLtlAuthService
      .initAuthSetup$(region)
      .pipe(
        mergeMap((regionInfo) => {
          return this.loggedInUserService.loggedInUser$.pipe(
            tap((user) => {
              const adminList = this.getMaintAdmins(regionInfo);
              const isAdmin = adminList.includes(user.emailAddress.toLowerCase());

              this.appConfigsService.isUserMaintAdmin.next(prod ? true : isAdmin);

              this.appConfigsService.isUserEnsemble.next(
                prod || isAdmin
                  ? true
                  : adminList
                      .filter((admin) => admin.includes('ensemble-'))
                      .some((admin) => admin.includes(user.emailAddress.toLowerCase()))
              );
            })
          );
        }),
        tap((_) => this.appConfigsService.loggedInComplete.next(true))
      )
      .subscribe();
  }

  private getMaintAdmins(regionInfo: RegionInfo) {
    return regionInfo && regionInfo.maintAdmins ? regionInfo.maintAdmins : [];
  }
}
